import { PeelingRateBasedEnum } from '@gtpl/shared-models/masters';
import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';

@Entity('deheading_peeling_chart')
export class DeheadingPeelingEntity {
  @PrimaryGeneratedColumn('increment', { name: 'deheading_peeling_chart_id' })
  deheadingpeelingId: number;

    @Column('varchar', {
        nullable: false,
        length: 250,
        name: 'scope_of_work',
    })
    scopeOfWork: string;
    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'grade',
    })
    grade: string;
    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'min_grade',
    })
    minGrade: number;

    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'max_grade',
    })
    maxGrade: number;

    @Column('decimal', {
        nullable: false,
        // length: 30,
        precision:10,scale:2,
        name: 'rate_per_kg',
    })
    ratePerKg: number;

    @Column('boolean', {
        nullable: false,
        name: 'isActive',
        default: true,
    })
    isActive: boolean | null;

    @Column('varchar', {
        nullable: false,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag',
    })
    versionFlag: number;

    @Column('int', {
        nullable: false,
        name: 'food_type_id',
    })
    foodTypeId: number;

    @Column('int', {
        nullable: false,
        name: 'value_add_1',
    })
    valueAdd1: number;

    @Column('int', {
        nullable: false,
        name: 'value_add_2',
    })
    valueAdd2: number;
    
    @Column('enum', {
        nullable: false,
        name: 'based_on',
        enum: PeelingRateBasedEnum
    })
    basedon: PeelingRateBasedEnum;
    
    @Column('int', {
        nullable: false,
        name: 'value_add_3',
    })
    valueAdd3: number;

    @Column('boolean',{
        name:'is_rrp',
        default:false
    })
    isRRP : boolean


    }

   

    
